// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__d8-VM","alert":"SettungsInbox_alert__3JyHG"};